const themesByAppName = {
  cruise: async () => await import('./cruise/Themes'),
  airline: async () => await import('./airline/Themes'),
  'labs:priorityFlight': async () => await import('./labs/priorityFlight/Themes'),
  manageMyBooking: async () => await import('./manageMyBooking/Themes'),
  eligibilityWidget: async () => await import('./eligibilityWidget/Themes'),
  globalMarketingPage: async () => await import('./globalMarketingPage/Themes'),
  rail: async () => await import('./rail/Themes'),
  /* NOTE: [new theme] add new appName here */
} as const;

export default themesByAppName;
